export const CONFIG = {
  "PROJECTNAME": "microfrucht",
  "COMPANYNAME": "Microfrucht",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10134001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#009e57",
    "primary100": "#b2e1cc",
    "light": "#009e57",
    "secondary": "#009e57",
    "dark": "#009e57",
    "siteColor3": "#fff",
    "menuSecondary": "#009e57"
  }
};